module.exports = __webpack_public_path__ + "static/img/banner4.5ee77e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner4.jpg
// module id = V+KJ
// module chunks = 12